import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Sanitizer, SecurityContext } from '@angular/core';

import { ModalComponent } from '../modal-component';


@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent extends ModalComponent<void> implements OnInit, AfterViewInit {

  public message: string;
  public title: string;
  @ViewChild('confirmButton')
  public confirmButton: ElementRef;
  @ViewChild('denyButton')
  public denyButton: ElementRef;
  private lastActiveElement: HTMLElement;

  constructor(
    private sanitizer: Sanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.lastActiveElement = document.activeElement as HTMLElement;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.denyButton.nativeElement.focus();
    }, 0);
  }

  public setMessage(message: string): void {
    this.message = this.sanitizer.sanitize(SecurityContext.HTML, message);
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public close() {
    super.close();

    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }

}



// WEBPACK FOOTER //
// /dist/src/app/notify/confirm/confirm.component.ts